import React from 'react';
import ReactDOM from 'react-dom';

import Homepage from './components/home.js';
import './assets/sass/style.scss';

ReactDOM.render(<Homepage />, document.getElementById('root'));
